// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterTwoToneSvg from "@fishx/icons-svg/es/asn/PrinterTwoTone";
import FishxIcon from '../components/FishxIcon';

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PrinterTwoToneSvg
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
export default React.forwardRef(PrinterTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PrinterTwoTone.js
// module id = 3848
// module chunks = 0